import { render, staticRenderFns } from "./qdhezuo.vue?vue&type=template&id=faf12b7c&scoped=true&"
import script from "./qdhezuo.vue?vue&type=script&lang=js&"
export * from "./qdhezuo.vue?vue&type=script&lang=js&"
import style0 from "./qdhezuo.vue?vue&type=style&index=0&id=faf12b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf12b7c",
  null
  
)

component.options.__file = "qdhezuo.vue"
export default component.exports